import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'extractDomain', standalone: true })
export class ExtractDomainPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value || typeof value !== 'string') {
      return '';
    }

    const trimmed = value.trim();
    if (!trimmed) {
      return '';
    }

    // Ensure we have a protocol so URL parsing is reliable
    const ensureProtocol = (url: string): string => {
      if (/^https?:\/\//i.test(url)) return url;
      return `https://${url}`;
    };

    try {
      const u = new URL(ensureProtocol(trimmed));
      let host = u.hostname.toLowerCase();
      // Strip leading www.
      host = host.replace(/^www\./, '');
      return host;
    } catch {
      // Fallback: basic extraction using regex
      const match = trimmed.match(/^(?:https?:\/\/)?([^\/\?:#]+)/i);
      if (match && match[1]) {
        return match[1].toLowerCase().replace(/^www\./, '');
      }
      return trimmed;
    }
  }
}
